import { useOrganization } from "@/context/organization.context";

export default function usePermissions() {
  const { memberShip } = useOrganization();
  const permissions = memberShip?.role?.permissions;
  return {
    canPerform: (permission: string) => {
      return permissions?.includes(permission);
    },
    permissions,
  };
}
